<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <div class="logo-icon">
          <el-icon :size="48" color="#7c8ff5">
            <Cloudy />
          </el-icon>
        </div>
        <h2 class="title">智慧水站监测平台</h2>
        <p class="subtitle">Water Quality Monitoring System</p>
      </div>

      <el-form ref="loginFormRef" :model="loginForm" :rules="rules" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.userName" placeholder="请输入用户名" size="large" clearable>
            <template #prefix>
              <el-icon color="#999">
                <User />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.passWord" type="password" placeholder="请输入密码" size="large" show-password
            @keyup.enter="handleLogin()">
            <template #prefix>
              <el-icon color="#999">
                <Lock />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="login-button" size="large" :loading="loading" @click="handleLogin()">
            立即登录
          </el-button>
        </el-form-item>

        <div class="login-footer">
          <span>© 2026 智慧水站监测平台 · 守护水质安全</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { User, Lock, Cloudy } from '@element-plus/icons-vue';
import setting from "../../config/setting"
import http from "../../utils/http"
export default defineComponent({
  components: {
    User,
    Lock,
    Cloudy
  },
  setup() {
    class InitData {
      loginForm = {
        id: 0,
        userName: '',
        passWord: '',
        permission: '',
        phone: '',
      }
    }
    const data = reactive(new InitData());
    const rules = {
      // userName: [
      //   { required: false, message: "请输入账号", trigger: "blur" },
      //   { min: 6, max: 14, message: "账号长度在6到14位之间", trigger: "blur" },
      // ],
      passWord: [
        { required: true, message: "请输入密码", trigger: "blur" },
        { min: 6, max: 14, message: "账号长度在6到14位之间", trigger: "blur" },
      ],
    };
    const router = useRouter();
    const handleLogin = () => {
      http.post(setting.LoginUrl, {
        userName: data.loginForm.userName,
        userPwd: data.loginForm.passWord,
      }).then((data) => {
        console.log('data', data)
        if (data.message != "登录成功") {
          ElMessage.success(data.message);
        } else {
          router.push("/user-home");
          //console.log(table)
          sessionStorage.setItem("LoginUserName", data.user.userName);
          sessionStorage.setItem("LoginUserId", data.user.Id);
          sessionStorage.setItem("LoginUserPwd", data.user.userPwd);
          sessionStorage.setItem("LoginPermissions", data.user.permissions);
          sessionStorage.setItem("userEquipment", data.user.userEquipment);
          sessionStorage.setItem("Loginuid", data.user.uid);
          ElMessage.success("登录成功");
        }
      }, (rej) => {
        console.log(rej)
        ElMessage.error(rej);
      })
      //console.log(table.permission)

    }
    onMounted(() => {
      history.pushState(null, "", document.URL);

      window.addEventListener(
        'popstate',
        function () {
          history.pushState(null, "", document.URL);
        }, false);
    });
    return {
      ...toRefs(data),
      rules,
      handleLogin,

    };
  },
});
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: backgroundMove 20s linear infinite;
}

@keyframes backgroundMove {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(50px, 50px);
  }
}

.login-box {
  width: 420px;
  padding: 48px 40px 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(20px);
  position: relative;
  z-index: 1;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 36px;
}

.logo-icon {
  margin-bottom: 16px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.title {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 1px;
}

.subtitle {
  margin: 0;
  color: #909399;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.login-form {
  margin-top: 0;
}

.login-form :deep(.el-form-item) {
  margin-bottom: 24px;
}

.login-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 24px;
  transition: all 0.3s ease;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(47, 84, 235, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

.login-footer {
  text-align: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}

.login-footer span {
  color: #909399;
  font-size: 12px;
}

:deep(.el-input__wrapper) {
  padding: 14px 16px;
  background: #f5f7fa;
  border: 1px solid transparent;
  border-radius: 12px;
  box-shadow: none;
  transition: all 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  background: #fff;
  border-color: #dcdfe6;
}

:deep(.el-input__wrapper.is-focus) {
  background: #fff;
  border-color: #2f54eb;
  box-shadow: 0 0 0 3px rgba(47, 84, 235, 0.1);
}

:deep(.el-input__inner) {
  font-size: 14px;
  color: #2c3e50;
}

:deep(.el-input__inner::placeholder) {
  color: #c0c4cc;
}

:deep(.el-form-item__error) {
  color: #f56c6c;
  font-size: 12px;
  padding-top: 4px;
}
</style>